import { PixKey } from './key.model';

export class PixNotification {
	tipoMovimentacaoConta: string;
	dataNotificacao: Date;
	codigoNotificacao: number;
	tipoNotificacao: PixNotificationType;
	lida: boolean;
	notificacaoPix: NotificacaoPix;
	notificacaoReivindicacaoRecebida: NotificacaoReivindicacaoRecebida;
	notificacaoReivindicacaoEnviada: NotificacaoReivindicacaoEnviada;
	notificacaoPixAgendadoNaoEfetivado: NotificacaoPixAgendadoNaoEfetivado;
	notificacaoPixDevolvidoAgendamentoNaoEfetivado: NotificacaoPixDevolvidoAgendamentoNaoEfetivado;
	notificacaoPixRecebimentoInfracao: NotificacaoPixRecebimentoInfracao;
	notificacaoOpenBankingConsentimentoPagamento: NotificacaoOpenBankingConsentimentoPagamento;
	notificacaoPagamentoCancelado: NotificacaoPagamentoCancelado;
	contaNotificacaoPixTransferenciaRecebidaSobAnalise: ContaNotificacaoPixTransferenciaRecebidaSobAnalise;
	contaNotificacaoBloqueioCautelarAutorizado: ContaNotificacaoBloqueioCautelarAutorizado
}
export class NotificacaoPix {
	numeroConta: number;
	tipoConta: string;
	dataConta: string;
	agencia: number;
	descricao: string;
	documento: string;
	codigoFimAFim: string;
	codigoFimAFimRetorno: string;
	ispbCodigo: string;
	ispbNome: string;
	nome: string;
	chave: string;
	dataTransacao: string;
	codigoTransacao: number;
	valor: number;
	medValorSolicitado: string;
	medResultadoAnalise: string;
	meddetalhes: string;
	contaNotificacaoPixTransferenciaDevolucaoEnviada: ContaNotificacaoPixTransferenciaDevolucaoEnviada;
}

export class ContaNotificacaoPixTransferenciaDevolucaoEnviada {
	contaTransacaoDevolucao: ContaTransacaoDevolucao;
	DataContabil: string;
	DataNotificacao: string;
	CodigoNotificacao: number;
	TipoNotificacao: string;
	Valor: number;
}

export class ContaTransacaoDevolucao {
	codigoOrigemSistema: number;
	numeroOrigemSistema: number;
	agenciaRecebedor: number;
	cpfCnpjRecebedor: string;
	codigoFimAFim: string;
	infoEntreUsuarios: string;
	ispbRecebedor: string;
	medDetalhes: string;
	medResultoAnalise: EMedResultoAnalise;
	medValorRequerido: number;
	nomeIspbRecebedor: string;
	nomeRecebedor: string;
	numeroContaRecebedor: number;
	codigoRequisicao: string;
	rtrId: string;
	tipoContaRecebedor: string;
	valor: number;
}
export class NotificacaoPixRecebimentoInfracao {
	dataCriacao: string;
	detalhes: string;
	codigoFimAFim: string;
	infracaoId: string;
	infracaoSequencia: string;
	tipoInfracao: ETipoInfracao;
	ISPBContraParte: string;
	nomeContraParte: string;
	dataModificacao: string;
	tipoInflacaoPix: EPixTipoInfracao;
	tipoReportado: ETipoReportado;
	analiseResultante: EAnaliseResultante;
	situacao: EInfracaoSituacao;
	valorBloqueado: number;
	medValorDevolvido: string;
	medResultadoAnalise: string;
	medDetalhes: string;
}

export class NotificacaoReivindicacaoRecebida {
	numeroConta: number;
	tipoConta: string;
	agencia: number;
	motivoCancelamentoReivindicacao: string;
	codigoReivindicacao: number;
	tipoReivindicacao: string;
	dataConclusao: string;
	documento: string;
	ispbCodigo: string;
	ispbNome: string;
	chave: PixKey;
	dataModificacao: string;
	nome: string;
	dataResolucao: string;
	situacaoReivindicacao: string;
}
export class NotificacaoReivindicacaoEnviada {
	motivoCancelamentoReivindicacao: string;
	codigoReivindicacao: number;
	tipoReivindicacao: string;
	dataConclusao: string;
	ispbCodigo: string;
	ispbNome: string;
	chave: PixKey;
	dataModificacao: string;
	dataResolucao: string;
	situacaoReivindicacao: string;
}

export class NotificacaoPixAgendadoNaoEfetivado {
	numeroConta: number;
	tipoConta: string;
	agencia: number;
	descricao: string;
	documento: string;
	codigoIspb: string;
	nome: string;
	chave: string;
	codigoMotivo: string;
	descricaoMotivo: string;
	dataTransacao: string;
	codigoTransacao: number;
	valor: number;
}

export class NotificacaoPixDevolvidoAgendamentoNaoEfetivado {
	numeroConta: number;
	tipoConta: string;
	agencia: number;
	descricao: string;
	documento: string;
	codigoIspb: string;
	nome: string;
	chave: string;
	codigoMotivo: string;
	descricaoMotivo: string;
	dataTransacao: string;
	codigoTransacao: number;
	valor: number;
}

export class NotificacaoOpenBankingConsentimentoPagamento {
	identificadorTransacao: string;
	tipoPagamento: number;
	tipoConsentimento: string;
	valor: number;
	dataCriacao: Date;
	dataExpiracao: Date;
	indicadorCNPJ: string;
	iniciadorNome: string;
	iniciadorMarca: string;
	nomeRecebedor: string;
	recebedor: string;
	tipoPessoa: string;
	usuario: string;
	tipoPessoaUsuario: string;
	empresa: string;
	quantidadeAutorizador: number;
}

export class NotificacaoPagamentoCancelado {
	codigoTransacao: number;
	valor: number;
	tipoNotificacao: string;
	codigoMotivo: string;
	descricaoMotivo: string;
}

export class ContaNotificacaoPixTransferenciaRecebidaSobAnalise{
    valor: number;
    endToEndId: string;
    nomeDoPagador: string;
    cpfCnpjDoPagador: string;
    ispbDoPagador: string;
    nomeIspbDoPagador: string;
    agenciaDoPagador: number;
    numeroDaContaDoPagador: string;
    tipoDaContaDoPagador: string;
}

class ContaNotificacaoBloqueioCautelarAutorizado {
	tipoTransacao: string;
	valor: number;
	endToEndId: string;
	nomeDoPagador: string;
	cpfCnpjDoPagador: string;
}  

export enum EMedResultoAnalise{
	NENHUM = 'None',
	TOTALMENTE_ACEITO = 'TOTALMENTE_ACEITO',
	PARCIALMENTE_ACEITO = 'PARCIALMENTE_ACEITO'
}

export enum EAnaliseResultante {
	NENHUM = 'None',
	CONCORDAR = 'CONCORDAR',
	DISCORDAR = 'DISCORDAR'
}

export enum EInfracaoSituacao{
	Aberta = 'ABERTA',
	Recebida = 'RECEBIDA',
	Fechado = 'FECHADA',
	Cancelado = 'CANCELADA',
	Devolucao = 'PIX_DEVOLUCAO_REALIZADO'
}

export enum ETipoInfracao{
	Fraude = 'FRAUDE',
	Devolucao = 'DEVOLUCAO',
	CancelamentoDevolucao = 'CANCELAMENTO_DEVOLUCAO'
}

export enum EPixTipoInfracao{
	PixEnviado = 'PIX_ENVIADO',
	PixRecibido = 'PIX_RECEBIDO'
}

export enum ETipoReportado{
	ISPBDebitado = 'ISPB_DEBITADO',
	ISPBCreditado = 'ISPB_CREDITADO'
}

export enum PixNotificationType {
	PIX_ENVIADO = 'PIX_ENVIADO',
	PIX_RECEBIDO = 'PIX_RECEBIDO',
	PIX_DEVOLUCAO_ENVIADA = 'PIX_DEVOLUCAO_ENVIADA',
	PIX_DEVOLUCAO_RECEBIDA = 'PIX_DEVOLUCAO_RECEBIDA',
	PIX_REIVINDICACAO_ENVIADA = 'PIX_REIVINDICACAO_ENVIADA',
	PIX_REIVINDICACAO_RECEBIDA = 'PIX_REIVINDICACAO_RECEBIDA',
	PIX_AGENDAMENTO_NAO_EFETIVADO = 'PIX_AGENDAMENTO_NAO_EFETIVADO',
	PIX_DEVOLVIDO_AGENDAMENTO_NAO_EFETIVADO = 'PIX_DEVOLVIDO_AGENDAMENTO_NAO_EFETIVADO',
	RECEBIMENTO_INFRACAO = 'RECEBIMENTO_INFRACAO',
	OPEN_BANKING_CONSENTIMENTO_PAGAMENTO = 'OPEN_BANKING_CONSENTIMENTO_PAGAMENTO',
	TRANSACAO_PAGAMENTO_CANCELADA = 'TRANSACAO_PAGAMENTO_CANCELADA',
	PIX_RECEBIDO_SOB_ANALISE_ANTIFRAUDE = "PIX_RECEBIDO_SOB_ANALISE_ANTIFRAUDE",
	BLOQUEIO_CAUTELAR_AUTORIZADO = "BLOQUEIO_CAUTELAR_AUTORIZADO"
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/notification.model.ts